<script lang="ts" setup>
/**
 * A reusable back button for GSheet components.
 * Renders as a circular button with a left arrow icon.
 */
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  disabled?: boolean
}>()

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <GSheetButton
    :disabled="disabled"
    class="g-sheet-button-back"
    :icon="faChevronLeft"
    @click="$emit('click', $event)"
  />
</template>
